import * as joint from '@joint/plus';

export default class ContextToolbarController {
  static render(service, point, selectedCells = []) {
    service.selection.collection.reset(selectedCells);
    const empty = selectedCells.length === 0;

    const toolbar = new joint.ui.ContextToolbar({
      target: point,
      root: service.paper.el,
      padding: 0,
      vertical: true,
      anchor: 'top-left',
      tools: [
        { action: 'delete', content: 'Delete', attrs: { disabled: empty } },
        { action: 'copy', content: 'Copy', attrs: { disabled: empty } },
        { action: 'paste', content: 'Paste', attrs: { disabled: service.clipboard.isEmpty() } },
        { action: 'send-to-front', content: 'Send to front', attrs: { disabled: empty } },
        { action: 'send-to-back', content: 'Send to back', attrs: { disabled: empty } },
      ],
    });

    toolbar.on('action:delete', () => {
      toolbar.remove();
      service.graph.removeCells(selectedCells);
    });
    toolbar.on('action:copy', () => {
      toolbar.remove();
      service.clipboard.copyElements(selectedCells, service.graph);
    });
    toolbar.on('action:paste', () => {
      toolbar.remove();
      const pasted = service.clipboard.pasteCellsAtPoint(service.graph, service.paper.clientToLocalPoint(point));
      service.selection.collection.reset(pasted.filter((c) => c.isElement()));
    });
    toolbar.on('action:send-to-front', () => {
      toolbar.remove();
      selectedCells.forEach((c) => c.toFront());
    });
    toolbar.on('action:send-to-back', () => {
      toolbar.remove();
      selectedCells.forEach((c) => c.toBack());
    });

    toolbar.render();
  }
}
